import axios, { AxiosResponse } from 'axios'
import { method } from './Types'

/*
const http = axios.create({
    baseURL: 'http://192.168.1.191:8081/api/',
    headers:{
        'Authorization': localStorage.getItem('@ecommerce/hash'),
    }
})
*/

const http = axios.create({
    baseURL: 'https://api.web.tiautomacao.com/api/',
    headers:{
        'Authorization': localStorage.getItem('@ecommerce/hash'),
    }
})



export const Api = async (url: string, httpMethod: method, params?: any, isFile: boolean = false): Promise<AxiosResponse<any, any>> => {

    let header = {}
    if (isFile){
        header = {
            'accept': 'application/json',
            'Content-Type': 'multipart/form-data'
        }        
    }
    
    switch(httpMethod){
        case 'get' : return await http.get(url, {params: params})
        case 'post': return await http.post(url, params, header)
        case 'put': return await http.put(url, params, header)
        case 'delete': return await http.delete(url, params)
    }
}